module.exports = __webpack_public_path__ + "media/images/banks/scb-260d9eeccafd4f0b1bf58a8932e02baf.png";